module.exports = __webpack_public_path__ + "img/relicalm-logo.4b20da39.png";